import { useLocation } from "react-router-dom";

const PHONE = "5551998789301";
const DEFAULT_MSG =
  "Olá! Vim pelo site da Paola Saldivia e gostaria de mais informações.";

const WhatsAppFloat = () => {
  const location = useLocation();

  // Hide on admin area
  if (location.pathname.startsWith("/admin")) return null;

  const isProduct = location.pathname.startsWith("/produto/");
  const url = typeof window !== "undefined" ? window.location.href : "";

  const message = isProduct
    ? `Olá! Tenho interesse neste produto: ${url}`
    : `${DEFAULT_MSG}${url ? `\n\n${url}` : ""}`;

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg ring-1 ring-black/5 transition-transform hover:scale-105 hover:bg-[#1ebe5d] focus:outline-none focus:ring-2 focus:ring-[#25D366]/60 sm:h-16 sm:w-16"
    >
      <img
        src="/whatsapp-logo-png.png"
        alt="WhatsApp"
        className="h-7 w-7 sm:h-8 sm:w-8"
        aria-hidden="true"
      />
    </a>
  );
};


export default WhatsAppFloat;